export default __webpack_public_path__ + "static/media/Mentores_por_Chile.1fb071be.svg";